import { apiClient as api } from './apiClient';
import type { ReconciliacionTransmision, ReconciliacionTraslado } from './reconciliacionApi';

export type EstadoCaso = 'NUEVO' | 'EN_ANALISIS' | 'INFO_SOLICITADA' | 'RESUELTO' | 'CERRADO' | 'RECHAZADO' | 'REABIERTO';
export type EntidadTipo = 'Farmacia' | 'Farmaceutico' | 'Transmision' | 'Empleado' | 'Traslado' | 'Incidencia';

export interface ComentarioCaso {
  id: number;
  casoId: number;
  autor: string;
  autorTipo: 'FCT' | 'Smartup';
  texto: string;
  creadoEn: string;
}

export interface CasoMejoraCU2 {
  id: number;
  codigo: string;
  sistemaDestino: string;
  entidadTipo: EntidadTipo;
  entidadRefId: number;
  reconciliacionId?: number;
  titulo: string;
  descripcion: string;
  estado: EstadoCaso;
  prioridad: 'Alta' | 'Media' | 'Baja';
  tratamientoSmartup?: string;
  mejoraIncorporada?: string;
  creadoPor: string;
  creadoEn: string;
  actualizadoEn?: string;
  cerradoPor?: string;
  cerradoEn?: string;
  comentarios?: ComentarioCaso[];
}

export interface CrearCasoRequest {
  entidadTipo: EntidadTipo;
  entidadRefId: number;
  reconciliacionId?: number;
  titulo: string;
  descripcion: string;
  prioridad?: 'Alta' | 'Media' | 'Baja';
}

export interface TransicionRequest {
  nuevoEstado: EstadoCaso;
  tratamientoSmartup?: string;
  mejoraIncorporada?: string;
  comentario?: string;
}

const buildQuery = (params: Record<string, string | undefined>): string => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v!)}`);
  return parts.length ? `?${parts.join('&')}` : '';
};

export const getCasos = async (estado?: string, entidadTipo?: string, prioridad?: string): Promise<CasoMejoraCU2[]> => {
  const res = await api.get(`/mejoracu2/casos${buildQuery({ estado, entidadTipo, prioridad })}`);
  return res.data;
};

export const getCaso = async (id: number): Promise<CasoMejoraCU2> => {
  const res = await api.get(`/mejoracu2/casos/${id}`);
  return res.data;
};

export const crearCaso = async (req: CrearCasoRequest): Promise<CasoMejoraCU2> => {
  const res = await api.post('/mejoracu2/casos', req);
  return res.data;
};

export const transicionarCaso = async (id: number, req: TransicionRequest): Promise<void> => {
  await api.post(`/mejoracu2/casos/${id}/transicion`, req);
};

export const comentarCaso = async (id: number, texto: string): Promise<void> => {
  await api.post(`/mejoracu2/casos/${id}/comentarios`, { texto });
};

export const eliminarCaso = async (id: number): Promise<void> => {
  await api.delete(`/mejoracu2/casos/${id}`);
};

/** Registro de transmisión vinculado al caso. null si no aplica. */
export const getRegistroTransmision = async (casoId: number): Promise<ReconciliacionTransmision | null> => {
  const res = await api.get(`/mejoracu2/casos/${casoId}/registro`);
  if (!res.data || !res.data.transmision) return null;
  return res.data.transmision as ReconciliacionTransmision;
};

/** Registro de traslado vinculado al caso. null si no aplica. */
export const getRegistroTraslado = async (casoId: number): Promise<ReconciliacionTraslado | null> => {
  const res = await api.get(`/mejoracu2/casos/${casoId}/registro`);
  if (!res.data || !res.data.traslado) return null;
  return res.data.traslado as ReconciliacionTraslado;
};
